// pages/OpenLeaks/components/FilterModal/FilterModal.tsx
import React, { useEffect } from 'react';
import { LeakFilters } from "features/openleak";
import { ReactComponent as IconClose } from 'assets/img/icons/icon_Close.svg';
import './FilterModal.scss';

interface FilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  filters: LeakFilters;
  onFilterChange: (filters: LeakFilters) => void;
  onReset: () => void;
}

const FilterModal: React.FC<FilterModalProps> = ({
                                                   isOpen,
                                                   onClose,
                                                   filters,
                                                   onFilterChange,
                                                   onReset
                                                 }) => {
  const [localFilters, setLocalFilters] = React.useState(filters);

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const handleApply = () => {
    onFilterChange(localFilters);
    onClose();
  };

  const handleReset = () => {
    setLocalFilters({});
    onReset();
    onClose();
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="filter-modal-overlay" onClick={onClose} />
      <div className="filter-modal">
        <div className="filter-modal__header">
          <h3 className="filter-modal__title">Filtrer les fuites</h3>
          <button className="filter-modal__close" onClick={onClose}>
            <IconClose width={20} height={20} />
          </button>
        </div>

        <div className="filter-modal__body">
          {/* Search */}
          <div className="filter-group">
            <label className="filter-label">Recherche</label>
            <input
              type="text"
              className="filter-input"
              placeholder="Nom de l'entreprise..."
              value={localFilters.search || ''}
              onChange={(e) => setLocalFilters({ ...localFilters, search: e.target.value })}
            />
          </div>

          {/* Status */}
          <div className="filter-group">
            <label className="filter-label">Statut</label>
            <select
              className="filter-select"
              value={localFilters.status || ''}
              onChange={(e) => setLocalFilters({ ...localFilters, status: e.target.value || undefined })}
            >
              <option value="">Tous les statuts</option>
              <option value="confirmed">Confirmée</option>
              <option value="claimed_credible">Revendiquée (crédible)</option>
              <option value="claimed_unreliable">Revendiquée (peu fiable)</option>
              <option value="unspecified">Non précisé</option>
            </select>
          </div>

          {/* Date Range */}
          <div className="filter-group">
            <label className="filter-label">Période</label>
            <div className="filter-date-range">
              <input
                type="date"
                className="filter-input"
                placeholder="Date début"
                value={localFilters.startDate || ''}
                onChange={(e) => setLocalFilters({ ...localFilters, startDate: e.target.value })}
              />
              <span className="date-separator">à</span>
              <input
                type="date"
                className="filter-input"
                placeholder="Date fin"
                value={localFilters.endDate || ''}
                onChange={(e) => setLocalFilters({ ...localFilters, endDate: e.target.value })}
              />
            </div>
          </div>

          {/* Affected Count Range */}
          <div className="filter-group">
            <label className="filter-label">Personnes concernées</label>
            <div className="filter-range">
              <input
                type="number"
                className="filter-input"
                placeholder="Min"
                value={localFilters.minAffected || ''}
                onChange={(e) => setLocalFilters({ ...localFilters, minAffected: e.target.value ? parseInt(e.target.value) : undefined })}
              />
              <span className="range-separator">-</span>
              <input
                type="number"
                className="filter-input"
                placeholder="Max"
                value={localFilters.maxAffected || ''}
                onChange={(e) => setLocalFilters({ ...localFilters, maxAffected: e.target.value ? parseInt(e.target.value) : undefined })}
              />
            </div>
          </div>
        </div>

        <div className="filter-modal__footer">
          <button className="filter-btn filter-btn--reset" onClick={handleReset}>
            Réinitialiser
          </button>
          <button className="filter-btn filter-btn--apply" onClick={handleApply}>
            Appliquer les filtres
          </button>
        </div>
      </div>
    </>
  );
};

export default FilterModal;